import React, { useState, useCallback, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import AppTopBar from './segments/AppTopBar';
import AllNotificationsModal from './shared/AllNotificationsModal';
import GuidedTour, { isFirstVisit } from './shared/GuidedTour';
import MobileBottomNav from './shared/MobileBottomNav';
import SnapfyAssistantLauncher from './assistant/SnapfyAssistantLauncher';
import { APP_HOME } from '../utils/segment';
const Layout: React.FC = () => {
    const [isAllNotificationsOpen, setIsAllNotificationsOpen] = useState(false);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
    const [runTour, setRunTour] = useState(false);
    const location = useLocation();
    const activePage = location.pathname;
    const isFullWidthPage = [APP_HOME, '/terms', '/privacy'].includes(activePage);

    // Auto-start tour on first visit
    useEffect(() => {
        if (isFirstVisit()) {
            const timer = setTimeout(() => setRunTour(true), 800);
            return () => clearTimeout(timer);
        }
    }, []);

    // Listen for mobile sidebar open event from MobileBottomNav
    useEffect(() => {
        const handleOpenSidebar = () => setIsMobileSidebarOpen(true);
        const handleOpenNotifications = () => setIsAllNotificationsOpen(true);
        window.addEventListener('open-mobile-sidebar', handleOpenSidebar);
        window.addEventListener('open-notifications', handleOpenNotifications);
        return () => {
            window.removeEventListener('open-mobile-sidebar', handleOpenSidebar);
            window.removeEventListener('open-notifications', handleOpenNotifications);
        };
    }, []);

    const handleStartTour = useCallback(() => {
        setRunTour(true);
    }, []);

    const handleTourComplete = useCallback(() => {
        setRunTour(false);
    }, []);

    return (
        <div className="flex min-h-screen bg-snapfy-bg text-snapfy-text-secondary font-sans">
            {/* Ambient brand glow — animated gradient orbs (home-hero hues) behind every
                page. First child on purpose: siblings paint above it in document order,
                so no z-index juggling; pointer-events-none keeps it inert. It's also what
                the app's glass (backdrop-blur) surfaces diffuse. */}
            <div aria-hidden className="snapfy-ambient">
                <div className="snapfy-ambient__orb snapfy-ambient__orb--1" />
                <div className="snapfy-ambient__orb snapfy-ambient__orb--2" />
                <div className="snapfy-ambient__orb snapfy-ambient__orb--3" />
            </div>
            <Sidebar
                onOpenAllNotifications={() => setIsAllNotificationsOpen(true)}
                isMobileOpen={isMobileSidebarOpen}
                onCloseMobile={() => setIsMobileSidebarOpen(false)}
                onStartTour={handleStartTour}
            />
            {/* min-w-0: sem isso o main (flex-1) não encolhe abaixo do conteúdo e páginas
                largas (ex. board do Kanban) clipam a ponta direita em vez de scrollar. */}
            <main className="flex-1 min-w-0 p-4 pb-28 sm:p-6 sm:pb-28 lg:p-8 lg:pb-8 flex flex-col">
                {/* Barra superior: seletor de segmento Fashion | Marketing. */}
                <AppTopBar />
                <div className={isFullWidthPage ? 'w-full min-w-0 flex-1' : 'max-w-[1920px] mx-auto w-full min-w-0 flex-1'}>
                    <Outlet />
                </div>
                <footer className="w-full mt-8 md:mt-12 pt-6 md:pt-8 border-t border-snapfy-border text-center text-snapfy-text-secondary text-xs md:text-sm">
                    © 2025 SNAPFY.AI LTDA. 57.189.141/0001-11
                </footer>
            </main>
            <AllNotificationsModal
                isOpen={isAllNotificationsOpen}
                onClose={() => setIsAllNotificationsOpen(false)}
            />
            <GuidedTour run={runTour} onComplete={handleTourComplete} />
            <MobileBottomNav />
            {/* Global Snapfy Assistant — one click away on every authenticated page. */}
            <SnapfyAssistantLauncher />
        </div>
    );
};

export default Layout;
